var _rect, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackMessage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6521_21507",
    transform: "matrix(0.00833333 0 0 0.0104167 0.1 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6521_21507",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEQklEQVR4nO2dXYgWVRjHf6alVhiBippGQpElKihJIGph1IUtgSFkF4U3UTfljbiuCIpZL+iNH6h1sZAgRXd9IJF2IXghKkpJoqLialAuun6upkZPHDhQybu8+86cOfOcmecH/5tlZ/d9/v+Zd86Z8zFgGIZhGIZhGIahhyHAVOAtYBXQDewDTgA9QB9wz6vP/+yE/51uf4w79nn/t4xBMANYCXzvTZVAugx8B3QC0y2J/zMdWA+cCmh4K50EPgam1TWMB4AOYE9E0wfSYeAdYBg1wBX5gf++FmU6B7xf5SBeAY4pMFpayN3IF1fpxj0Z+EmBsdKm9gJPkTDuDHoPuK7ATMmofuCjFK+Gx3xTUiqib4FRJMLTwK8KTJPAcs3kKSjnpcAdKFGmPl+jSuYDNxWYJBHuC65Fp4rXgFsKzJFI+hN4HSW8CNxWYIpEljvhZpdt/gTgNwVmSEn6HZhUlvmPAEcUmCAKniWNLCOA7QqKFyXaHNv8BcDfCgoXJXJevBrL/FFKn2ZKyToLPBojgE8UFCtKtbZo88fXpLMlGXUDGFdkADsUFCnKtbUo80f7HmDZBYpy3QHGFhFAp4LiJBEtL2IQ/ayCwiQRnfaeBeNlBUVJYpoXMoCNCgqSxNQIGUAVR7ikYP0SyvwnFRQjiWpiiAAWKShEEtUbIQJYraAQSVRdIQL4SkEhkqh2hQjgcOAP1QpRfnw7OkQAXKfCAiDzXKLc9FoAZD0BL4YIIPQDuFaI8uPbkfMuNxYAmQNw03Vy4y4juwLI5MEfIQJw66ksADIv9sjNQQuArCeg8y431hEjcwDOu9ysCvwVVCetDhFAh4JCJFG5B5m5maSgEElUzxIIG5AhUxM02OK+hoKzSRLTFwRkjoKCJDG9HTKAocB5BUVJIvoLGENgVigoTBLRbgrgcZuYS9TmZzNsci6Dav08WFQAE/062bIvcVGsTymYNQqKFKXqL2pm9H9xKwJtiRJNA3BTOKOw0Bbp0WzhdqGrY+5nk4JLXhRpHZEZDhxVULgoUI9fuB6dZwqYtiJ1nQOaldk1Xzn5DQpY4BenSc3UG/vG22rkrE57BgnwJsqYC1xRYIxE0Oco3gu66h21Q8AIlG9b+bUCo6QAXfKb0arHjYcuq9jN+a5fspsUrq/wgwLzJMCeQO+SMB2J3xu6qAAPAx8mGMQWKoYbMVoK/KzA3Fb6LMXNu9t9b8wGpdtfdofedEMzQ/0msO4lPj8qGPrcVifzm/EQMNO/isoNg34JHACOAxeAq96ofr+p9pmAUygbVf/aKRLJOaHK9V2MHOTZcK/U5/pVQTLINQBmlf3Bq4JkWMfltuM0AtGO+Tt959AIyGCMd292WhLynxr/0sr8I/4BoVEQAxl/z7fvXf/CKBAZYAO9F8z1OMh9AygNP4nMiBzAfuA5cz0+1/z7H2v9IK1Mnij7AxiGYZAG/wDCT5jACFWASQAAAABJRU5ErkJggg=="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMessage);
export default __webpack_public_path__ + "static/media/blackMessage.de59eef03f45caa77ac0988dff0a5696.svg";
export { ForwardRef as ReactComponent };